"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _AIChatContext = require("./AIChatContext");
var _Core = require("../../Core");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var AIChatDialogContainer = _styledComponents["default"].div.withConfig({
  displayName: "AIChatDialog__AIChatDialogContainer",
  componentId: "sc-1ck2nzc-0"
})(["width:400px;height:600px;padding:10px;display:flex;flex-direction:column;color:black;border-radius:5px;"]);
var AIChatDialogMessages = _styledComponents["default"].div.withConfig({
  displayName: "AIChatDialog__AIChatDialogMessages",
  componentId: "sc-1ck2nzc-1"
})(["display:flex;flex-direction:column-reverse;width:100%;height:500px;justify-content:end;background:white;border-radius:5px;padding:5px;overflow-y:auto;::-webkit-scrollbar{width:10px;}::-webkit-scrollbar-track{background:#f1f1f1;}::-webkit-scrollbar-thumb{border-radius:3px;background:#888;}::-webkit-scrollbar-thumb:hover{background:#555;}"]);
var AIChatDialogInput = _styledComponents["default"].div.withConfig({
  displayName: "AIChatDialog__AIChatDialogInput",
  componentId: "sc-1ck2nzc-2"
})(["display:flex;height:100px;margin-top:10px;background:white;border-radius:5px;padding:5px;"]);
var AIChatDialogWelcomeMessage = _styledComponents["default"].div.withConfig({
  displayName: "AIChatDialog__AIChatDialogWelcomeMessage",
  componentId: "sc-1ck2nzc-3"
})(["display:flex;flex-direction:column;align-items:center;margin-bottom:30px;width:100%;"]);
var AIChatDialogMessage = _styledComponents["default"].div.withConfig({
  displayName: "AIChatDialog__AIChatDialogMessage",
  componentId: "sc-1ck2nzc-4"
})(["display:flex;flex-direction:column;align-items:start;width:100%;"]);
var AIChatDialog = function AIChatDialog() {
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var _useContext2 = (0, _react.useContext)(_AIChatContext.AIChatContext),
    messages = _useContext2.messages,
    isLoading = _useContext2.isLoading,
    sendMessage = _useContext2.sendMessage;
  var _React$useState = _react["default"].useState(false),
    isOpen = _React$useState[0],
    setIsOpen = _React$useState[1];
  var _React$useState2 = _react["default"].useState(""),
    message = _React$useState2[0],
    setMessage = _React$useState2[1];
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var mapMessage = function mapMessage(message) {
    var isHuman = (message == null ? void 0 : message.length) > 0 ? message[0] === _AIChatContext.HUMAN : false;
    var isError = (message == null ? void 0 : message.length) > 0 ? message[0] === _AIChatContext.ERROR : false;
    return /*#__PURE__*/_react["default"].createElement(AIChatDialogMessage, null, /*#__PURE__*/_react["default"].createElement("strong", null, isHuman ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      icon: _icons.IconNames.USER,
      size: _core.IconSize.STANDARD
    }), " ", translate("AIChatDialog.You", "You")) : isError ? "" : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      icon: _icons.IconNames.CLEAN,
      size: _core.IconSize.STANDARD
    }), " ", translate("AIChatDialog.bot.name", "Sarathy"))), /*#__PURE__*/_react["default"].createElement("p", {
      style: {
        whiteSpace: "pre-wrap",
        textAlign: isError ? "center" : "left",
        marginLeft: "20px"
      }
    }, (message == null ? void 0 : message.length) > 0 ? message[1] : null));
  };
  var handleSendMessage = function handleSendMessage(e) {
    if (e.key === "Enter" && e.shiftKey === false) {
      e.preventDefault();
      sendMessage(message);
      setMessage("");
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Popover, {
    className: theme.AIChatDialogPopupTheme + " ai-chat-button-container",
    position: _core.Position.BOTTOM_RIGHT,
    canEscapeKeyClose: true,
    isOpen: isOpen,
    enforceFocus: false,
    onClose: function onClose() {
      return setIsOpen(false);
    },
    shouldDismissPopover: false,
    content: /*#__PURE__*/_react["default"].createElement(AIChatDialogContainer, {
      "data-testid": "AIChatIcon.Container"
    }, /*#__PURE__*/_react["default"].createElement(AIChatDialogMessages, null, isLoading ? /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        height: "50px"
      }
    }, /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null)) : null, messages == null ? void 0 : messages.map(function (message) {
      return mapMessage(message);
    }), /*#__PURE__*/_react["default"].createElement(AIChatDialogWelcomeMessage, null, translate("AIChatDialog.WelcomeMessage", "Hi! I am your assistant. How can I help you?"))), /*#__PURE__*/_react["default"].createElement(AIChatDialogInput, null, /*#__PURE__*/_react["default"].createElement("textarea", {
      style: {
        width: "100%",
        resize: "none",
        border: "none"
      },
      onChange: function onChange(e) {
        return setMessage(e.target.value);
      },
      value: message,
      onKeyDown: handleSendMessage
    })))
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    className: "ai-chat-button",
    "data-testid": "AIChatIcon.Button",
    icon: _icons.IconNames.CLEAN,
    onClick: function onClick() {
      setIsOpen(!isOpen);
    },
    style: {
      marginRight: "10px"
    }
  }))));
};
var _default = exports["default"] = AIChatDialog;